import $ from 'cash-dom';
import React from 'react';
import ReactDOM from 'react-dom';

import VideoPlayer from 'components/VideoPlayer';
import Rudderstack from 'utils/Rudderstack';
import GENERIC_CTA_CLICKED_EVENT from 'utils/Rudderstack/constants';

const VideoPlayerController = class {
  static mountVideoPlayer = (element, props) => {
    ReactDOM.render(<VideoPlayer {...props} />, element);
  };

  static handleCTAClick = element => {
    const $element = $(element);
    const cta = $element.find('.video-poster-play-button');
    const poster = $element.find('.video-poster');
    cta.on('click', () => {
      poster.hide();

      Rudderstack.callToActionClicked({
        type: GENERIC_CTA_CLICKED_EVENT.TYPES.BUTTON,
        location: GENERIC_CTA_CLICKED_EVENT.LOCATIONS.PARTNERSHIP_PAGE,
        name: 'Video Played',
        url: window.location.href,
      });
    });
  };

  static init = () => {
    $('[data-id="allbirds-video-player-block"]').each((index, element) => {
      const $element = $(element);

      const url = $element.data('url');
      const aspectRatio = $element.data('aspect-ratio');
      const poster = $element.data('poster');
      const playing = $element.data('playing');
      const playsinline = $element.data('playsinline');
      const loop = $element.data('loop');
      const muted = $element.data('muted');
      const controls = $element.data('controls');

      const shouldPlayOnWindowReady = playing;

      const props = {
        aspectRatio,
        url,
        playing: false,
        loop,
        muted,
        controls,
        poster,
        playsinline,
        lazy: false,
      };

      VideoPlayerController.mountVideoPlayer(element, props);

      if (shouldPlayOnWindowReady) {
        $(document).ready(() => {
          VideoPlayerController.mountVideoPlayer(element, { ...props, playing: true });
        });
      }
    });

    $('[data-id="allbirds-video-wrapper-block"]').each((_, element) => {
      VideoPlayerController.handleCTAClick(element);
    });
  };
};

export default VideoPlayerController;
